"use strict";

require("./_image-as-link-to-product");